import { Box, Button } from '@mui/material';
import { LoginButtonBlocks } from '../../LoginButtonsBlock/LoginButtonBlocks';
import { ELoginMode } from '../../../Helper/enums';
import { LoginTermsBlock } from '../../LoginTermsBlock/LoginTermsBlock';
import { LoginTemplateProps } from '../../types';
import { useIsDesktop, useIsLandscape } from '../../../../utils';
import './style.scss';
import { useEffect, useState } from 'react';
import { checkIfOlderOsVersions } from '../../../Helper/utils/utils';

const saleTextImage =
    'https://media.appcharge.com/media/login-images/sale-text-10%25.png';
const mobileInfoJackpotSlots =
    'https://media.appcharge.com/media/login-images/JMS-how_does_it_work2.png';
const mobileInfoBigFish =
    'https://media.appcharge.com/media/login-images/BFC-infographic-mobile3.png';
const JMS_desktopLogo =
    'https://media.appcharge.com/media/login-images/JMS_login-logo-desk.png';
const BFC_desktopLogo =
    'https://media.appcharge.com/media/login-images/BFC_login-logo-desk.png';
const privacyPolicyLinkCustom = 'https://www.productmadness.com/privacy-notice';
const termsAndConditionsLinkCustom =
    'https://www.productmadness.com/terms-of-service';

export const ProductMadnessLogin = ({
    loginProps,
    handleBackBtnClicked,
    gameName
}: LoginTemplateProps) => {
    const { mode, openInfoModal, onContactSupport, logo, textColor } =
        loginProps;
    const [isOldVersion, setIsOldVersion] = useState<string>('');
    const isDesktop = useIsDesktop();
    const isLandscape = useIsLandscape();
    const desktopLogo =
        gameName === 'jackpot-slots' ? JMS_desktopLogo : BFC_desktopLogo;

    const mobileHowDoesItWorkImage =
        gameName === 'jackpot-slots'
            ? mobileInfoJackpotSlots
            : mobileInfoBigFish;

    useEffect(() => {
        if (checkIfOlderOsVersions()) {
            setIsOldVersion('ac-login-page--ios13');
        }
    }, []);

    return (
        <>
            <div
                className={`ac-login-page ac-login-page--jackpot-slots ${isOldVersion}`}
                style={{ color: textColor }}
            >
                <Box
                    display={'flex'}
                    flexDirection={'column'}
                    alignItems={'center'}
                    justifyContent={'space-between'}
                    className={'ac-login-page__top-container'}
                >
                    <div className={'ac-login-page__logo'}>
                        <img
                            alt="game logo"
                            src={isDesktop || isLandscape ? desktopLogo : logo}
                        ></img>
                    </div>
                    {mode === ELoginMode.PROVIDERS && (
                        <div className={'ac-login-page__sale-image'}>
                            <img src={saleTextImage} alt={'sale-image'}></img>
                        </div>
                    )}
                    <LoginButtonBlocks {...loginProps} maxWidth={'320px'} />
                    {mode !== ELoginMode.PROVIDERS && (
                        <button
                            className="backButton"
                            onClick={handleBackBtnClicked}
                        >
                            Back
                        </button>
                    )}
                </Box>
            </div>
            <div className={'ac-login-page__footer-container ' + gameName}>
                {!(isDesktop || isLandscape) &&
                    mode === ELoginMode.PROVIDERS && (
                        <img
                            className="ac-login-page__footer-container__image"
                            src={mobileHowDoesItWorkImage}
                            alt={'infographic'}
                        />
                    )}
                <div
                    className={`ac-login-page__footer-container__footer-text ${gameName}`}
                >
                    <LoginTermsBlock
                        className={'login-terms-block'}
                        textSize={'12px'}
                        openInfoModal={openInfoModal}
                        privacyPolicyLink={privacyPolicyLinkCustom}
                        termsAndConditionsLink={termsAndConditionsLinkCustom}
                        openInNewTab={true}
                        translations={loginProps.translations}
                    ></LoginTermsBlock>
                    <div className={'login-terms-text'}>
                        Must be 18+ to play/access/make a purchase. In-app
                        purchases (includes random items) optional. No real
                        world money or prizes can be won
                    </div>
                    <Button
                        variant="text"
                        sx={{
                            textTransform: 'none',
                            fontSize: '12px',
                            padding: '5px 0 0'
                        }}
                        onClick={() => onContactSupport?.()}
                        className={'contact-support-button'}
                    >
                        Contact support
                    </Button>
                </div>
            </div>
        </>
    );
};
